module.exports = __webpack_public_path__ + "img/vote-table.af6bfbd6.png";